import CotizadorCV from "./controladorVista/cotizadorCV"

export const Cotizador = () => {
    return <CotizadorCV />;
}
